import { Directive, nextTick } from "vue";
import * as tippy from "tippy.js";

export const appTippyVisible: Directive<
    HTMLElement & { readonly _tippy?: tippy.Instance },
    boolean
> = {
    mounted(el, bindings) {
        nextTick(() => {
            if (bindings.value) {
                el._tippy?.show();
            } else {
                el._tippy?.hide();
            }
        });
    },
    updated(el, bindings) {
        nextTick(() => {
            if (bindings.value) {
                el._tippy?.show();
            } else {
                el._tippy?.hide();
            }
        });
    },
};
